<template>

 <router-link :to="to" v-bind:style="{backgroundColor:backgroundColor, color:color}" class="ui-button">
   <div class="top">
      <div class="left" v-if="$slots.left" ><slot name="left"></slot></div>
      <div class="title">
        <slot name="title"></slot>
        
       
        <div class="subtitlebtn"><slot name="subtitlebtn"></slot></div>
        
      </div>
      <div class="right"><slot name="right"></slot></div>
  </div>
  </router-link>

</template>

<script>
export default {
  name: 'ui-button',
  props:{
    backgroundColor:{ default:'#DDDDDD' },
    color:{ default:'#000000' },
    to:{default:""},
  },
  computed:{
    
  },
  data:function(){
    return {
    }
  },
  methods:{
  },
  mounted:function(){
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.top{
  
  display:flex;
  width:100%;
  align-items:center;
  border-radius:4px;
}

.subtitlebtn{  
  font-size:.8em;
  color:#646464;
}

.ui-button{
  padding:8px 10px;
  text-decoration:none;
  position:relative;
  width:100%;
  border-radius:4px;
  display:inline-flex;
  font-size:1em;
  margin-bottom:5px;
  cursor:pointer;
  display:flex;
  flex-direction: column;
  transition: background-color .25s;
  /*border-bottom:2px solid rgba(0,0,0,.1);*/
}

.title{
  flex:1;
  /*overflow: hidden;
  white-space: nowrap;
 text-overflow: ellipsis;
 margin-right:5px;*/
}


.left,.right{
    display: flex;
    align-items: center;
   
}
/* icon margin left slot */
.left{
  margin-right:5px;
  
}
/* icon margin right slot */
.right *{
  margin-left:5px;
}
</style>
